import { DialogActions } from '@mui/material';
import React from 'react';

import { Button } from '@/components/Button';

import { buttonSx } from '../../constants/styles';

import s from './DialogFooter.module.scss';

type DialogFooterProps = {
  isEdit?: boolean;
  isFormValid: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  onSubmit: () => void;
};

export const DialogFooter: React.FC<DialogFooterProps> = ({
  isEdit,
  isFormValid,
  isSubmitting,
  onCancel,
  onSubmit,
}) => {
  return (
    <DialogActions>
      <div className={s.buttons}>
        <Button sx={buttonSx} variant="outlined" onClick={onCancel} disabled={isSubmitting}>
          <p>Отмена</p>
        </Button>
        <Button
          sx={buttonSx}
          variant="contained"
          onClick={onSubmit}
          disabled={!isFormValid || isSubmitting}
        >
          <p>{isEdit ? 'Изменить' : 'Добавить'}</p>
        </Button>
      </div>
    </DialogActions>
  );
};
